"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _chunkPOE2IUJUjs = require('./chunk-POE2IUJU.js');var _chunkMQ5AGG7Cjs = require('./chunk-MQ5AGG7C.js');var _chunkACTHRI52js = require('./chunk-ACTHRI52.js');var _chunkYYYYMYLYjs = require('./chunk-YYYYMYLY.js');var _chunk3OA3TISXjs = require('./chunk-3OA3TISX.js');var _chunk6A7N44T6js = require('./chunk-6A7N44T6.js');var _chunkOL2KRAIPjs = require('./chunk-OL2KRAIP.js');var _styled = require('@emotion/styled'); var _styled2 = _interopRequireDefault(_styled);var _react = require('react'); var _react2 = _interopRequireDefault(_react);var _jsxruntime = require('react/jsx-runtime');var P=_styled2.default.a`
  display: flex;
  flex-flow: column;
  cursor: pointer;
  width: fit-content;
  max-width: ${e=>e.theme.measurements.spacing(136)};
`,W=_styled2.default.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  gap: ${e=>e.theme.measurements.spacing(1.5)};
  margin-bottom: ${e=>e.theme.measurements.spacing(1.5)};
`,w=_styled2.default.div`
  width: ${e=>e.$width||"60%"};
  height: ${e=>e.theme.measurements.spacing(1)};
  background: ${e=>e.theme.palette.DIVIDER};
  border-radius: ${e=>e.theme.measurements.shape(5)};
`,q=_styled2.default.div`
  position: relative;
  display: block;
  min-height: fit-content;
  min-width: fit-content;
  height: ${e=>e.theme.measurements.spacing(78)};
  img {
    width: 100%;
    max-width: ${e=>e.theme.measurements.spacing(136)};
    height: ${e=>e.theme.measurements.spacing(78)};
    border-radius: ${e=>e.theme.measurements.shape(2)};
  }
`,H=_styled2.default.div`
  display: flex;
  flex-flow: column;
  position: absolute;
  bottom: ${e=>e.theme.measurements.spacing(6)};
  gap: ${e=>e.theme.measurements.spacing(4)};
  left: ${e=>e.theme.measurements.spacing(6)};
  right: ${e=>e.theme.measurements.spacing(6)};
`,O=_styled2.default.div`
  display: flex;
  align-items: flex-end;
`,F=_styled2.default.div`
  display: flex;
  gap: ${e=>e.theme.measurements.spacing(4)};
  justify-content: flex-start;
  flex: 1;
`,V=_styled2.default.call(void 0, _chunkPOE2IUJUjs.a)`
  text-transform: uppercase;
  padding: ${e=>e.theme.measurements.spacing(2)}
    ${e=>e.theme.measurements.spacing(3)};
`,Y=_styled2.default.div`
  display: flex;
  flex-flow: column;
  margin-top: ${e=>e.theme.measurements.spacing(6)};
  gap: ${e=>e.theme.measurements.spacing(3)};
`,_=_styled2.default.call(void 0, _chunkMQ5AGG7Cjs.a)`
  line-height: ${e=>e.theme.measurements.spacing(12)};
  font-weight: 600;
`,j=_styled2.default.div`
  display: flex;
  flex-flow: column;
  gap: ${e=>e.theme.measurements.spacing(4)};

  svg {
    color: ${e=>e.theme.palette.SECONDARY};
    margin-right: ${e=>e.theme.measurements.spacing(4)};
  }
`,G=_styled2.default.div`
  display: flex;
  flex-direction: row;
  gap: ${e=>e.theme.measurements.spacing(4)};
  align-items: center;
`,J=_styled2.default.call(void 0, _chunkMQ5AGG7Cjs.a)`
  color: ${e=>e.$topicColor||e.theme.palette.VIOLET};
  font-size: ${e=>e.theme.measurements.spacing(6)};
  font-weight: 700;
  line-height: ${e=>e.theme.measurements.spacing(6)};
  text-transform: uppercase;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`,s=_styled2.default.div`
  font-size: ${e=>e.theme.measurements.spacing(7)};
  line-height: ${e=>e.theme.measurements.spacing(10)};
  color: ${e=>e.theme.palette.SECONDARY};
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  display: flex;
  align-items: top;
`,K=_styled2.default.call(void 0, s)``,Q=_styled2.default.call(void 0, s)``,U=_styled2.default.call(void 0, s)``,X=_styled2.default.call(void 0, s)``,Z=_styled2.default.call(void 0, _chunkPOE2IUJUjs.a)`
  white-space: nowrap;
`,ee=_styled2.default.div`
  margin-top: ${e=>e.theme.measurements.spacing(4)};
  display: flex;
  flex-direction: column;
  gap: ${e=>e.theme.measurements.spacing(3)};
`,te=_react2.default.forwardRef((e,C)=>{let{title:l,langLabel:T="EN",variant:v,showTopLines:x=!0,isCentreBatch:y=!1,topicName:L,topicColor:I,startsIn:r,batchTiming:h,as:N="a",educatorNames:o,ariaLabel:E,dataTestId:R,className:D,onClick:p,href:k,newTab:M,thumbnail:d,actionButtons:i}=e,S=_chunkOL2KRAIPjs.b.call(void 0, ),A=g=>{!p||(g.preventDefault(),p(g))};return _jsxruntime.jsxs.call(void 0, P,{ref:C,className:`${D||""} aquilla-batchcard batchcard`,onClick:A,href:k,"aria-label":E,"data-testid":R,title:l,rel:"noopener noreferrer",target:M?"_blank":"_self",as:N,children:[x&&_jsxruntime.jsxs.call(void 0, W,{children:[_jsxruntime.jsx.call(void 0, w,{$width:"60%"}),_jsxruntime.jsx.call(void 0, w,{$width:"75%"})]}),_jsxruntime.jsxs.call(void 0, q,{children:[d?_jsxruntime.jsx.call(void 0, d,{}):"",_jsxruntime.jsx.call(void 0, H,{children:_jsxruntime.jsx.call(void 0, O,{children:_jsxruntime.jsx.call(void 0, F,{children:v==="live"?_jsxruntime.jsx.call(void 0, V,{variant:"solid",color:S.RED,size:"small",children:"Live"}):""})})})]}),_jsxruntime.jsxs.call(void 0, Y,{children:[_jsxruntime.jsxs.call(void 0, G,{children:[_jsxruntime.jsx.call(void 0, Z,{variant:"default",size:"small",children:T}),_jsxruntime.jsx.call(void 0, J,{as:"div",variant:"p2",$topicColor:I,children:L})]}),_jsxruntime.jsx.call(void 0, _,{as:"div",variant:"h5",children:l}),_jsxruntime.jsxs.call(void 0, j,{children:[y&&_jsxruntime.jsxs.call(void 0, K,{children:[_jsxruntime.jsx.call(void 0, _chunk6A7N44T6js.b,{height:20,width:16})," Centre"]}),r?_jsxruntime.jsxs.call(void 0, Q,{title:r,children:[_jsxruntime.jsx.call(void 0, _chunkACTHRI52js.b,{height:20,width:16})," ",r]}):"",h?_jsxruntime.jsxs.call(void 0, U,{children:[_jsxruntime.jsx.call(void 0, _chunkYYYYMYLYjs.b,{height:20,width:16})," ",h]}):"",o?_jsxruntime.jsxs.call(void 0, X,{title:o,children:[_jsxruntime.jsx.call(void 0, _chunk3OA3TISXjs.b,{height:20,width:16})," ",o]}):""]}),(i==null?void 0:i.length)&&_jsxruntime.jsx.call(void 0, ee,{children:i})]})]})}),he= exports.a =te;exports.a = he;
